import React, { createContext, useCallback, useContext, useState } from 'react';
import { createPortal } from 'react-dom';

const HeaderSlotContext = createContext(null);

export const HEADER_SELECT_CLASS = 'w-40 sm:w-56';

export function HeaderSlotProvider({ children }) {
  const [slot, setSlot] = useState(null);
  const registerSlot = useCallback((node) => {
    setSlot(node);
  }, []);

  return (
    <HeaderSlotContext.Provider value={{ slot, registerSlot }}>
      {children}
    </HeaderSlotContext.Provider>
  );
}

export function HeaderActionsSlot({ className }) {
  const { registerSlot } = useContext(HeaderSlotContext);
  return <div ref={registerSlot} className={className} />;
}

/** Renders page controls into the white top bar, on the right. */
export function PageHeaderActions({ children }) {
  const ctx = useContext(HeaderSlotContext);
  if (!ctx?.slot) return null;
  return createPortal(children, ctx.slot);
}
